import { render, staticRenderFns } from "./NotFoundPage.html?vue&type=template&id=592e3058&scoped=true&"
import script from "./NotFoundPage.js?vue&type=script&lang=js&"
export * from "./NotFoundPage.js?vue&type=script&lang=js&"
import style0 from "./NotFoundPage.scss?vue&type=style&index=0&id=592e3058&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592e3058",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VImg,VRow})
